import { clsx, type ClassValue } from 'clsx';
import { twMerge } from 'tailwind-merge';

/**
 * Merges class names, letting a later conflicting Tailwind utility win.
 *
 * The shadcn/ui convention. Without the merge step, passing `className="p-0"` to a
 * component whose base classes include `p-2` would leave both in the attribute and
 * the outcome would depend on stylesheet order rather than on the caller's intent.
 */
export function cn(...inputs: ClassValue[]): string {
  return twMerge(clsx(inputs));
}
